import React from 'react';
import { formatPercent } from 'utils';
import { TooltipBase } from './';

const TooltipRiskScatterChart = ({ payload }: any) => {
  const data = payload[0] && payload[0].payload;

  if (!data) return null;

  return (
    <TooltipBase>
      <p>Name: {data.name}</p>
      <p>Annualised Volatility: {formatPercent(data.standard_deviation)}</p>
      <p>
        Cumulative Total Return Performance: {formatPercent(data.performance)}
      </p>
    </TooltipBase>
  );
};

export default TooltipRiskScatterChart;
